import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import HeightIcon from '@mui/icons-material/Height';
import HotelIcon from '@mui/icons-material/Hotel';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import SpeedIcon from '@mui/icons-material/Speed';
import StraightenIcon from '@mui/icons-material/Straighten';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import type { BoxProps } from '@mui/material/Box';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { JucyIcon } from '@/components/JucyIcon';
import { mergeSx } from '@/lib/mergeSx';
export interface VehicleSpecChipsProps extends BoxProps {
  odometer?: number;
  year?: number;
  engineCapacity?: number;
  fuelCapacity?: number;
  berths?: number;
  length?: number;
  width?: number;
  height?: number;
  internalHeight?: number;
  orientation?: 'horizontal' | 'vertical';
}
export function VehicleSpecChips(t0) {
  const $ = _c(46);
  let berths;
  let engineCapacity;
  let fuelCapacity;
  let height;
  let internalHeight;
  let length;
  let odometer;
  let props;
  let sx;
  let t1;
  let width;
  let year;
  if ($[0] !== t0) {
    ({
      orientation: t1,
      sx,
      odometer,
      year,
      engineCapacity,
      fuelCapacity,
      berths,
      length,
      width,
      height,
      internalHeight,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = berths;
    $[2] = engineCapacity;
    $[3] = fuelCapacity;
    $[4] = height;
    $[5] = internalHeight;
    $[6] = length;
    $[7] = odometer;
    $[8] = props;
    $[9] = sx;
    $[10] = t1;
    $[11] = width;
    $[12] = year;
  } else {
    berths = $[1];
    engineCapacity = $[2];
    fuelCapacity = $[3];
    height = $[4];
    internalHeight = $[5];
    length = $[6];
    odometer = $[7];
    props = $[8];
    sx = $[9];
    t1 = $[10];
    width = $[11];
    year = $[12];
  }
  const orientation = t1 === undefined ? "horizontal" : t1;
  const t2 = orientation === "horizontal" ? "row" : "column";
  let t3;
  if ($[13] !== sx || $[14] !== t2) {
    t3 = mergeSx({
      display: "flex",
      flexDirection: t2,
      justifyContent: "space-between",
      gap: 1,
      mb: 2
    }, sx);
    $[13] = sx;
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== year) {
    t4 = year ? <Chip icon={<CalendarMonthIcon />} label={year} title={`Year of manufacture: ${year}`} /> : null;
    $[16] = year;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== berths) {
    t5 = berths ? <Chip icon={<HotelIcon />} label={`${berths} berth${berths > 1 ? "s" : ""}`} title={`Sleeps up to ${berths} people`} /> : null;
    $[18] = berths;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== odometer) {
    t6 = odometer ? <Chip icon={<SpeedIcon />} label={`${odometer} km`} title={`Odometer reading: ${odometer} kilometers`} /> : null;
    $[20] = odometer;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== engineCapacity) {
    t7 = engineCapacity ? <Chip icon={<JucyIcon icon="engine" fontSize="medium" />} label={`${engineCapacity}L`} title={`Engine capacity: ${engineCapacity} litres`} /> : null;
    $[22] = engineCapacity;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== length) {
    t8 = length ? <Chip icon={<JucyIcon icon="motorhome" />} label={`${length}m`} title={`Vehicle length: ${length} meters`} /> : null;
    $[24] = length;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== fuelCapacity) {
    t9 = fuelCapacity ? <Chip icon={<LocalGasStationIcon />} label={`${fuelCapacity}L`} title={`Fuel tank capacity: ${fuelCapacity} litres`} /> : null;
    $[26] = fuelCapacity;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== width) {
    t10 = width ? <Chip icon={<StraightenIcon />} label={`${width}m`} title={`Vehicle width: ${width} meters`} /> : null;
    $[28] = width;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== height) {
    t11 = height ? <Chip icon={<HeightIcon />} label={`${height}m`} title={`Vehicle height: ${height} meters`} /> : null;
    $[30] = height;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== internalHeight) {
    t12 = internalHeight ? <Chip icon={<VerticalAlignTopIcon />} label={`${internalHeight}m`} title={`Internal standing height: ${internalHeight} meters`} /> : null;
    $[32] = internalHeight;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== props || $[35] !== t10 || $[36] !== t11 || $[37] !== t12 || $[38] !== t3 || $[39] !== t4 || $[40] !== t5 || $[41] !== t6 || $[42] !== t7 || $[43] !== t8 || $[44] !== t9) {
    t13 = <Box sx={t3} {...props}>{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}</Box>;
    $[34] = props;
    $[35] = t10;
    $[36] = t11;
    $[37] = t12;
    $[38] = t3;
    $[39] = t4;
    $[40] = t5;
    $[41] = t6;
    $[42] = t7;
    $[43] = t8;
    $[44] = t9;
    $[45] = t13;
  } else {
    t13 = $[45];
  }
  return t13;
}